/* eslint-disable no-unused-vars */

// CSS - normalize.css - import vendor css
//import '../node_modules/modern-normalize/modern-normalize.css'

// CSS 
import './tailwind.css';

import './base/defaults.css';
import './base/forms.css'
import './base/richtext.css'
import './base/section-blocks.css'

import './buttons/buttons.css';
import './buttons/password-reveal.css'
import './buttons/accordion.css'

// Header
import './header/actions.css'
import './header/search.css'
import './header/overlay.css'
import './header/sticky.css'
import './header/mobile-nav-button.css'

import './vendor/autocomplete.min.css'
import './header/autocomplete.css'

import './nav/nav.css'
import './nav/megamenu.css'

// Products
import './products/product-code.css'
import './products/sticky.css'
import './products/stock.css'

// Carousel - chunk
// import Swiper styles
// These are not in the chunk because the carousel is used above the fold
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import './carousel/defaults.css'
// If page has carousel, load js chunk
const hasCarousel = document.querySelector('.swiper')
if (hasCarousel) {
    import('./carousel/carousel').then(({ default: Carousel }) => {
        const CarouselSet = new Carousel();
        CarouselSet.init();
    })
}

// Sticky Header - Adds js-is-sticky class on scroll
import StickyHeader from './header/sticky';
const sticky = new StickyHeader();

// Make all buttons in group same width based on largest width
import setMinWidth from './buttons/widths';
const setMinWidth1 = new setMinWidth();

// On load
window.addEventListener('load', () => {

    // Add js class to html
    document.querySelector('html.no-js').className = 'js';

    // Scroll to the top of the page on load
    const scrollToTop = document.querySelector('body.on-load-scroll-top');
    if (scrollToTop) {
        window.scrollTo(0, 0);
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 500);
    }

})
